import React from "react";
import { useState } from "react";
import { FcSearch } from "react-icons/fc";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { IMG_API } from "../../api/endPoint";
import Modal from "../common/Modal";
import NoRecord from "../common/NoRecord";
import Search from "../common/Search";
import AddUser from "../Setting/AddUser";
import Manager from "../Teams/Manager";
import PlayerDetail from "./PlayerDetail";
import emptyProfile from "../../assets/SVG/empty-profile1.png";
import OtherTeam from "./OtherTeam";

export default function Index({ data, match, otherteam }) {
  let avatar = [];
  const [search, setSearch] = useState("");
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const [detail, setDetail] = useState(false);
  const [playerData, setPlayerData] = useState(null);
  const handlePlayerDetail = () => {
    setDetail(true);
  };
  let players = [];

  data?.filter((items) => {
    if (search === "") {
      return players.push(items);
    } else if (
      items?.firstname?.toLowerCase().includes(search.toLowerCase()) ||
      items?.lastname?.toLowerCase().includes(search.toLowerCase())
    ) {
      return players.push(items);
    }
  });
  const [create, setCreate] = useState(false);
  const HandleCreateshow = () => {
    setCreate(true);
  };
  const params = useParams();
  const { hash } = useLocation();

  console.log(data, "hahah data");

  return (
    <div className="">
      <div className="flex gap-3 items-baseline mb-3">
        <Search handleSearch={handleSearch} />
        {!match ? (
          <button
            onClick={HandleCreateshow}
            type="button"
            className=" w-full h-[40px] rounded-md border border-transparent bg-[#0F3A62] px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-[#fff] hover:border-[#0F3A62] hover:text-[#0F3A62] focus:outline-none focus:ring-2 focus:ring-[#0F3A62] focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Add Player
          </button>
        ) : otherteam == null ? (
          <NavLink
            to={`/comparison/${params?.id}/${params?.teamid}/${hash}`}
            type="button"
            className=" w-full h-[40px] rounded-md border border-transparent bg-[#0F3A62] px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-[#fff] hover:border-[#0F3A62] hover:text-[#0F3A62] focus:outline-none focus:ring-2 focus:ring-[#0F3A62] focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Compare Team Players
          </NavLink>
        ) : (
          ""
        )}
      </div>
      {players?.length != 0 ? (
        <div className="wrapper">
          {players?.map((items) => (
            <div
              onClick={(e) => {
                handlePlayerDetail(e);
                setPlayerData(items);
              }}
              class="fut-player-card"
            >
              <div class="player-card-top">
                <div class="player-master-info">
                  <div class="player-rating">
                    <span>{items?.overall == null ? 0 : items?.overall}</span>
                  </div>
                  <div class="player-position">
                    <span>{items?.position}</span>
                  </div>
                  {/* <div class="player-nation">
                    <img src={IElogo} alt="IE" draggable="false" />
                  </div> */}
                  <div class="player-club">
                    <img
                      src={`${IMG_API}/${items?.teamlogo}`}
                      alt="Barcelona"
                      draggable="false"
                    />
                  </div>
                </div>
                <div class="player-picture">
                  {items?.avatar != null ? (
                    <img
                      src={`${IMG_API}/${items?.avatar}`}
                      alt={items?.firstname}
                      draggable="false"
                    />
                  ) : (
                    <img
                      src={emptyProfile}
                      alt={items?.firstname}
                      draggable="false"
                    />
                  )}

                  {/* <div class="player-extra">
                    <span>4*SM</span>
                    <span>4*WF</span>
                  </div> */}
                </div>
              </div>

              <div class="player-card-bottom">
                <div class="player-info">
                  <div class="player-name">
                    <span>{items?.firstname}</span>
                  </div>

                  <div class="player-features">
                    <div class="player-features-col">
                      <span>
                        <div class="player-feature-value">
                          {items?.pace == null ? 0 : items?.pace}
                        </div>
                        <div class="player-feature-title">PAC</div>
                      </span>
                      <span>
                        <div class="player-feature-value">
                          {" "}
                          {items?.shooting == null ? 0 : items?.shooting}
                        </div>
                        <div class="player-feature-title">SHO</div>
                      </span>
                      <span>
                        <div class="player-feature-value">
                          {items?.passing == null ? 0 : items?.passing}
                        </div>
                        <div class="player-feature-title">PAS</div>
                      </span>
                    </div>
                    <div class="player-features-col">
                      <span>
                        <div class="player-feature-value">
                          {items?.dribbling == null ? 0 : items?.dribbling}
                        </div>
                        <div class="player-feature-title">DRI</div>
                      </span>
                      <span>
                        <div class="player-feature-value">
                          {items?.defending == null ? 0 : items?.defending}
                        </div>
                        <div class="player-feature-title">DEF</div>
                      </span>
                      <span>
                        <div class="player-feature-value">
                          {items?.physical == null ? 0 : items?.physical}
                        </div>
                        <div class="player-feature-title">PHY</div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <NoRecord />
      )}
      {otherteam == null && match ? <OtherTeam /> : ""}

      {create ? <AddUser teamid={params?.id} modal={setCreate} /> : ""}
      {detail ? <PlayerDetail data={playerData} modal={setDetail} /> : ""}
    </div>
  );
}
